class ReceptoldalV2 {

    constructor() {
        this.init();
    }

    init()
    {
        // a filter-kategóriák
        $('.receptekoldal2024 .top-items .filter-selectors-kont .filter-item > a').on('click', (ev) => {
            ev.preventDefault();
            ev.stopPropagation();
            let el = ev.currentTarget;
            let panelId = $(el).attr('id');

            if (window.innerWidth > 991) {
                if (panelId == 'termekenkent')
                {
                    $('.receptekoldal2024 .filter-panel.termekenkent .kategselector .kategselector-links a:not(.closeme):first').trigger('click');
                }
            }

            if ($('.receptekoldal2024 .filter-panel.' + panelId).hasClass('off')) {
                $('.receptekoldal2024 .filter-panel').addClass('off');
                $('.receptekoldal2024 .filter-panel.' + panelId).removeClass('off');
            } else {
                $('.receptekoldal2024 .filter-panel.' + panelId).addClass('off');
                $('.receptekoldal2024 .filter-panel.termekenkent .kategselector').removeClass('kateg-filter-active');
                $('.receptekoldal2024 .filter-panel.termekenkent .kategselector-panels .kateg-panel').addClass('off');
            }

        });

        // a termékes filteren belüli panelek
        $('.receptekoldal2024 .filter-panel.termekenkent .kategselector .kategselector-links a:not(.closeme)').on('click', (ev) => {
            ev.preventDefault();
            ev.stopPropagation();
            let el = ev.currentTarget;
            let selKat = $(el).data("kateg");

            $('.receptekoldal2024 .filter-panel.termekenkent .kategselector .kategselector-links a').removeClass('active');
            $('.receptekoldal2024 .filter-panel.termekenkent .kategselector').addClass('kateg-filter-active');
            $(el).addClass('active');

            $('.receptekoldal2024 .filter-panel.termekenkent .kategselector-panels .kateg-panel').addClass('off');
            $('.receptekoldal2024 .filter-panel.termekenkent .kategselector-panels .kateg-panel[data-panel_kateg='+selKat+']').removeClass('off');

        });

        $('.receptekoldal2024 .filter-panel .kategselector-panels .close-kateg').on('click', (ev) => {
            ev.preventDefault();
            ev.stopPropagation();
            $('.receptekoldal2024 .filter-panel.termekenkent .kategselector').removeClass('kateg-filter-active');
            $('.receptekoldal2024 .filter-panel.termekenkent .kategselector-panels .kateg-panel').addClass('off');
        });
    }

    menuListOpen(el)
    {
        var menu = $(el).data('menu');

        $('.recept-bal .menuitems-kont li a').removeClass('active');
        $(el).addClass('active');

        if (menu == "kategoriak")
        {
            $('.etrendek-items').addClass('hide');
            $(el).next('.kategoria-items').removeClass('hide');
        }

        if (menu == "etrendek")
        {
            $('.kategoria-items').addClass('hide');
            $(el).next('.etrendek-items').removeClass('hide');
        }

        return false;
    }

    changeTermekkategoria2024(el)
    {
        var selKat = $(el).data("kateg");
        $('.receptekoldal2024 .filter-panel.termekenkent .kategselector .kategselector-links a').removeClass('active');
        $(el).addClass('active');

        $('.receptekoldal2024 .filter-panel.termekenkent .kategselector-panels .kateg-panel').addClass('off');
        $('.receptekoldal2024 .filter-panel.termekenkent .kategselector-panels .kateg-panel[data-panel_kateg='+selKat+']').removeClass('off');

        return false;
    }

    openReceptListaFiltersPanel2024(el)
    {
        console.log('openReceptListaFiltersPanel2024');
        let panelId = $(el).attr('id');

        if (panelId == 'termekenkent')
        {
            $('.receptekoldal2024 .filter-panel .kategselector .kategselector-links a:not(.closeme):first').trigger('click');
        }

        if ($('.receptekoldal2024 .filter-panel.' + panelId).hasClass('off')) {
            $('.receptekoldal2024 .filter-panel').addClass('off');
            $('.receptekoldal2024 .filter-panel.' + panelId).removeClass('off');
        } else {
            $('.receptekoldal2024 .filter-panel.' + panelId).addClass('off');
        }


        return false;
    }

    receptlistapanelCloseMe2024(el)
    {
        if ($(el).parents('.filter-panel').length > 0) {
            $(el).parents('.filter-panel').addClass('off');
        }
        if ($(el).parents('.suggest-content').length > 0) {
            $(el).parents('.suggest-content').removeClass('opened').empty();
            $('.receptekoldal2024 .receptek-top .top-items .top-item.kereso input[type="text"]').val('').blur();
        }
        return false;
    }

    changeTermekkategoria(el)
    {
        var selKat = $(el).val();
        $('.receptoldal-kont .selectors-kont .sub-selector-termekek-kont select').addClass('hide');
        $('.receptoldal-kont .selectors-kont .sub-selector-termekek-kont #termekselect_'+selKat).removeClass('hide');
    }

    changeTermek(sel)
    {
        var selKat = ""+$(sel).val().replace(/^(\d+)_\d+$/, "$1");
        var selTerm = ""+$(sel).val().replace(/^\d+_(\d+)$/, "$1");

        var termeknevSlug = $(sel).find("[value="+$(sel).val()+"]").data('termeknev')
        var destpage = $(sel).find("[value="+$(sel).val()+"]").data('termeknevurl')

        // console.log(destpage, termeknevSlug)
        document.location.href = destpage+"?m=termekek&termek="+termeknevSlug+"&k="+selKat+'&t='+selTerm;
    }

    changeTermek2024(el)
    {
        var selKat = ""+$(el).data('panel_item_id').replace(/^(\d+)_\d+$/, "$1");
        var selTerm = ""+$(el).data('panel_item_id').replace(/^\d+_(\d+)$/, "$1");

        var termeknevSlug = $(el).data('termeknev');
        var destpage = $(el).data('termeknevurl');

        document.location.href = destpage+"?m=termekek&termek="+termeknevSlug+"&k="+selKat+'&t='+selTerm;
        return false;
    }

    changeSef2024(el) {
        let sef_id = +$(el).data('sef_id');

        $('.receptekoldal2024 .kategoriak-links a').removeClass('active');
        $(el).addClass('active');
        if (sef_id == -1) {
            $('.receptekoldal2024 .receptek-lista .recilista .reci').removeClass('off');
        } else {
            $('.receptekoldal2024 .receptek-lista .recilista .reci').addClass('off');
            $('.receptekoldal2024 .receptek-lista .recilista .reci[data-sefid=' + sef_id + ']').removeClass('off');

            document.location.hash = 'sef=' + sef_id;
        }
        return false;
    }

    changeSefUrlInit()
    {
        let sef = document.location.hash.replace('#sef=', '');
        if (sef != '') {
            $('.receptekoldal2024 .kategoriak-links a').removeClass('active');
            $('.receptekoldal2024 .kategoriak-links a[data-sef_id='+sef+']').addClass('active');
            if (sef == -1) {
                $('.receptekoldal2024 .receptek-lista .recilista .reci').removeClass('off');
            } else {
                $('.receptekoldal2024 .receptek-lista .recilista .reci').addClass('off');
                $('.receptekoldal2024 .receptek-lista .recilista .reci[data-sefid='+sef+']').removeClass('off');
            }
        }

    }

    changeMobileSelectFormAction(el)
    {
        document.location.search = $(el).val();
    }
}

export default ReceptoldalV2;
